import React, { useCallback } from 'react';

import { Stack } from '@lp/ds-next';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import useShipmentsStore, {
  createEmptyShipmentSearchTerms,
  dispatchSelector,
} from '../../shipments/hooks/useShipmentsStore';
import { IShipment } from '@/features/shipments/models/shipment';

const GoToBoxShipmentButton = ({
  boxId,
  shipment,
  partnerId,
  partner,
}: {
  boxId?: string;
  shipment?: IShipment;
  partnerId?: string;
  partner?: any;
}) => {
  const dispatch = useShipmentsStore(dispatchSelector);

  const buttonClickHandler = useCallback(() => {
    const nextSearchTerms = createEmptyShipmentSearchTerms();
    if (boxId) {
      nextSearchTerms.boxId = boxId;
    }

    if (partnerId) {
      nextSearchTerms.partnerId = partnerId;
    }

    const partnerAutocomplete: [{ id: string; name: string }] | undefined =
      partnerId && partner
        ? [{ id: partner.id, name: partner.name ?? partner.clientName ?? '' }]
        : undefined;

    dispatch({
      type: 'overrideSearchContext',
      args: {
        searchTerms: nextSearchTerms,
        ...(partnerAutocomplete && { partnerAutocomplete }),
      },
    });
  }, [dispatch, boxId, partnerId, partner]);

  return (
    <Stack direction="row" gap="1rem">
      {boxId && shipment && (
        <Link to={`/shipments/${shipment.id}`}>
          <Button type="primary">To Shipment</Button>
        </Link>
      )}
      {(boxId || partnerId) && (
        <Link to="/shipments" onClick={buttonClickHandler}>
          <Button type="primary">To Shipments</Button>
        </Link>
      )}
    </Stack>
  );
};

export default GoToBoxShipmentButton;
